interface FormMainProps {
  children: React.ReactNode;
}

export const FormMain = ({ children }: FormMainProps) => {
  return <div>{children}</div>;
};
